module.exports = __webpack_public_path__ + "node_modules/font-awesome/fonts/fontawesome-webfont.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.woff2?v=4.7.0
// module id = 169
// module chunks = 0